import { CatalogProductSchema } from "@redotech/redo-model/catalog/catalog-product-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const VariantPriceUpdateSchema_ = z.object({
  variantId: zExt.objectId(),
  price: z.number().positive(),
});

export const VariantPriceUpdateSchema: z.ZodType<VariantPriceUpdate> =
  VariantPriceUpdateSchema_;
export interface VariantPriceUpdate
  extends z.infer<typeof VariantPriceUpdateSchema_> {}

export const updateMarketplaceListing = {
  name: "updateMarketplaceListing" as const,
  input: z.object({
    catalogProductId: zExt.objectId(),
    brand: z.string().optional(),
    variantUpdates: z.array(VariantPriceUpdateSchema).optional(),
  }),
  output: z.object({ catalogProduct: CatalogProductSchema }),
};
